export default __webpack_public_path__ + "static/media/franchising-banner.012ad733.png";